import React from "react";
import { motion } from "framer-motion";

// List of industries served
const serviceList = [
    "Information Technology (IT)",
    "Healthcare",
    "Construction",
    "Hospitality",
    "Manufacturing",
    "Retail",
    "Finance and Accounting",
    "Logistics and Supply Chain",
    "Education",
    "Telecommunications",
    "Automotive",
    "Energy and Utilities",
    "Pharmaceuticals",
    "Real Estate",
    "Agriculture",
    "Media and Entertainment",
    "Non-Profit Organizations",
    "Aerospace and Defense",
    "Insurance",
    "Food and Beverage",
    "Fashion and Apparel",
    "Environmental Services",
    "Security Services",
    "Travel and Tourism",
    "Biotechnology",
    "Construction and Engineering",
    "Mining and Metals",
    "Chemical Manufacturing",
    "Textiles",
    "Consumer Electronics",
    "Sports and Recreation",
    "Public Sector",
    "Government Services",
    "Legal Services",
    "Human Resources",
    "Marketing and Advertising",
    "Public Relations",
    "Event Management",
    "Interior Design",
    "Graphic Design",
    "Web Development",
    "E-commerce",
    "Social Media Management",
    "Data Analytics",
    "Artificial Intelligence",
    "Cloud Computing",
    "Cybersecurity",
    "Telemarketing",
    "Call Center Services",
    "Research and Development",
    "Quality Assurance",
    "Technical Support",
    "Supply Chain Management",
    "Inventory Management",
    "Retail Management",
    "Business Consulting",
    "Corporate Training",
    "Sales and Business Development",
    "Product Management",
    "Digital Marketing",
    "SEO Services",
    "Content Creation",
    "Translation Services",
    "Import and Export",
    "Logistics Management",
    "Fleet Management",
    "Warehouse Management",
    "Construction Management",
    "Urban Planning",
    "Civil Engineering",
    "Electrical Engineering",
    "Mechanical Engineering",
    "Chemical Engineering",
    "Environmental Engineering",
    "Nuclear Engineering",
    "Petroleum Engineering",
    "Marine Engineering",
    "Robotics",
    "Telecommunications Engineering",
    "Network Administration",
    "Database Management",
    "System Administration",
    "Help Desk Support",
    "Field Service Management",
    "Home Health Care",
    "Pharmacy Services",
    "Medical Billing and Coding",
    "Health Information Management",
    "Occupational Therapy",
    "Physical Therapy",
    "Veterinary Services",
    "Dental Services",
    "Mental Health Services",
    "Public Health",
    "Emergency Services",
    "Fire Services",
    "Law Enforcement",
    "Military Services",
    "Disaster Recovery Services",
    "Waste Management",
    "Recycling Services",
    "Sustainability Consulting",
    "Renewable Energy",
    "Solar Energy",
    "Wind Energy",
    "Hydropower",
    "Geothermal Energy",
    "Nuclear Energy",
    "Fossil Fuels",
    "Natural Gas",
    "Coal Mining",
    "Oil and Gas Exploration",
    "Marine Biology",
    "Wildlife Conservation",
    "Forestry Services",
    "Agricultural Engineering",
    "Food Safety",
    "Culinary Arts",
    "Beverage Production",
    "Catering Services",
    "Event Planning",
    "Wedding Planning",
    "Corporate Events",
    "Trade Shows",
    "Exhibitions",
    "Film Production",
    "Television"
];

const IndustriesServedPage = () => {
    return (
        <>
            {/* About Section */}
            <div className="other-pages-main-section-v9">
                <motion.h2
                    className="enquiry-heading"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    Industries We Serve
                </motion.h2>
            </div>

            {/* Service Cards Section */}
            <div className="services-card-container industries-served">
                {serviceList.map((service, index) => (
                    <motion.div
                        key={index}
                        className="service-card"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: index * 0.1 }}
                    >
                        <h3 className="service-card-title">{service}</h3>
                    </motion.div>
                ))}
            </div>
        </>
    );
}

export default IndustriesServedPage;
